import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGES]: {
		url:'/company/:companyId/regulations/:regulationId/stages/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].CREATE_REGULATIONS_STAGE]: {
		url:'/company/:companyId/regulations/:regulationId/stages/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].PATCH_REGULATIONS_STAGE]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].PUT_REGULATIONS_STAGE]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].DELETE_REGULATIONS_STAGE]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}